// @src/pre-deployment/src/components/TrackingService/index.js v2.0
// - Barrel export file for TrackingService component folder
// - Provides centralized imports for all tracking services, hooks, and utilities
// - Part of tracking system migration from src/pre-deployment/src/tracking/

// Import services for legacy combined object (must be at top per ESLint)
import { ContentDiscoveryService as _CDS } from './services/ContentDiscoveryService.js';
import { LearningProgressService as _LPS } from './services/LearningProgressService.js';
import { MasteryService as _MS } from './services/MasteryService.js';
import { TrackingV2Service as _TVS } from './services/TrackingV2Service.js';

// ============================================================================
// SERVICES
// ============================================================================

export { silentTrack } from './services/SilentTrackService.js';
export { ContentDiscoveryService } from './services/ContentDiscoveryService.js';
export { LearningProgressService } from './services/LearningProgressService.js';
export { MasteryService } from './services/MasteryService.js';
export { TrackingV2Service } from './services/TrackingV2Service.js';
export { TrackingCRUDService } from './services/TrackingCRUDService.js';

// ============================================================================
// UTILITIES
// ============================================================================

export {
    getLearningProgressPath,
    getMasteryPath,
    getLearningProgressRef,
    getMasteryRef
} from './utils/PathBuilders.js';

export { DataParametersService } from './utils/DataParameters.js';

// ============================================================================
// HOOKS
// ============================================================================

export { useChapterTracking } from './hooks/useChapterTracking.js';
export { useLearningProgress } from './hooks/useLearningProgress.js';
export { useMasteryData } from './hooks/useMasteryData.js';
export { useContentDiscovery } from './hooks/useContentDiscovery.js';
export { useKnowledgeProfile } from './hooks/useKnowledgeProfile.js';

// ============================================================================
// UI COMPONENTS
// ============================================================================

export {
    TrackingProgressDisplay,
    MasteryDisplay,
    ContentDiscoveryDisplay,
    TrackingDebugPanel
} from './components/index.js';

// ============================================================================
// LEGACY COMPATIBILITY
// ============================================================================

// Combined service object for backward compatibility with default imports
const TrackingV2 = {
    ..._CDS,
    ..._LPS,
    ..._MS,
    ..._TVS
};

export default TrackingV2;
